/* eslint-disable unicorn/filename-case */
// TODO: Remove the above line after the ESLint config is fixed.

'use client'; // Error boundaries must be Client Components
import { useEffect } from 'react';

import { DEFAULT_LANGUAGE, i18n } from '@/__generated__/i18n';
import { createDateTimeFormatter } from '@/infrastructures/atDecorators/memoize';
import { reportClientError } from '@/infrastructures/reportClientError';

const GlobalError: React.FC<{ error: Error & { digest?: string }; reset: () => void }> = ({ error }) => {
  const t = i18n(DEFAULT_LANGUAGE);
  const dateFormatter = createDateTimeFormatter(undefined, {
    dateStyle: 'medium',
    timeStyle: 'medium',
  });
  useEffect(() => {
    console.error(error);
    reportClientError(error);
  }, [error]);

  return (
    <html lang={DEFAULT_LANGUAGE}>
      <body>
        <div style={{ padding: '16px' }}>
          <div
            style={{
              borderRadius: '8px',
              padding: '16px',
              backgroundColor: '#f8d7da',
              color: '#721c24',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <strong style={{ display: 'flex', alignItems: 'center' }}>
                {t.pages.error.unexpectedError()}
                <span style={{ color: '#6c757d', fontSize: 'small', marginLeft: '8px' }}>
                  ({dateFormatter.format()})
                </span>
              </strong>
            </div>

            <p>{t.pages.error.unexpectedErrorMessage()}</p>
          </div>
        </div>
      </body>
    </html>
  );
};

export default GlobalError;
